import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from "react";
import { useTheme } from "styled-components";
import { Flyout } from "../../navigation";
import { Icon } from "../../icon";
import { Wrapper, FlyoutWrapper } from "./LanguageSwitch.styles";
import { Dropdown } from "./Dropdown.styles";
export var KeyBoardKeys;
(function (KeyBoardKeys) {
    KeyBoardKeys["Escape"] = "Escape";
    KeyBoardKeys["Enter"] = "Enter";
    KeyBoardKeys["ArrowUp"] = "ArrowUp";
    KeyBoardKeys["ArrowDown"] = "ArrowDown";
    KeyBoardKeys["Space"] = "Space";
})(KeyBoardKeys || (KeyBoardKeys = {}));
export function LanguageSwitch({ languages, onClick, currentLanguage, alignByContent, previewId, dataEditType, previewIdExtractor, }) {
    const [focused, setFocused] = useState(false);
    const [flyoutOpen, setFlyoutOpen] = useState(false);
    const [items, setItems] = useState();
    const theme = useTheme();
    const dropDownRef = useRef(null);
    const wrapperRef = useRef(null);
    function generateFlyoutItems() {
        const flyoutItems = languages.map((lang) => ({
            content: Object.assign({}, lang),
            isActive: currentLanguage === lang.value,
            symbol: currentLanguage === lang.value ? "Checkmark" : "",
        }));
        if (!(JSON.stringify(flyoutItems) === JSON.stringify(items))) {
            setItems(flyoutItems);
        }
    }
    useEffect(() => {
        generateFlyoutItems();
    }, [currentLanguage, languages]);
    function toggleFlyout() {
        setFlyoutOpen((prev) => !prev);
    }
    const onDocumentClick = (e) => {
        var _a;
        if (!((_a = dropDownRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
            setFlyoutOpen(false);
        }
    };
    function onKeyDownHandler(ev) {
        if (ev.code === KeyBoardKeys.ArrowDown) {
            const htmlListElement = wrapperRef.current.querySelectorAll("li");
            const firstLiElement = htmlListElement[0];
            if (ev.target.contains(dropDownRef.current)) {
                firstLiElement.focus();
            }
            else {
                for (let liItemIndex = 0; liItemIndex < htmlListElement.length; liItemIndex += 1) {
                    if (document.activeElement.contains(htmlListElement[liItemIndex])) {
                        if (liItemIndex < htmlListElement.length - 1) {
                            const nextElement = htmlListElement[liItemIndex + 1];
                            nextElement.focus();
                        }
                        else {
                            firstLiElement.focus();
                        }
                        break;
                    }
                }
            }
        }
        if (ev.code === KeyBoardKeys.ArrowUp) {
            const htmlListElement = wrapperRef.current.querySelectorAll("li");
            const lastLiElement = htmlListElement[htmlListElement.length - 1];
            if (ev.target.contains(dropDownRef.current)) {
                lastLiElement.focus();
            }
            else {
                for (let liItemIndex = 0; liItemIndex < htmlListElement.length; liItemIndex += 1) {
                    if (document.activeElement.contains(htmlListElement[liItemIndex])) {
                        if (liItemIndex > 0) {
                            const prevElement = htmlListElement[liItemIndex - 1];
                            prevElement.focus();
                        }
                        else {
                            lastLiElement.focus();
                        }
                        break;
                    }
                }
            }
        }
        if (ev.code === KeyBoardKeys.Enter || ev.code === KeyBoardKeys.Space) {
            const htmlListElement = wrapperRef.current.querySelectorAll("li");
            if (!ev.target.contains(dropDownRef.current)) {
                for (let htmlListElementIndex = 0; htmlListElementIndex < htmlListElement.length; htmlListElementIndex += 1) {
                    if (document.activeElement.contains(htmlListElement[htmlListElementIndex])) {
                        htmlListElement[htmlListElementIndex].click();
                        break;
                    }
                }
            }
        }
        if (ev.code === KeyBoardKeys.Escape) {
            setFlyoutOpen(false);
        }
    }
    useEffect(() => {
        if (flyoutOpen) {
            document.addEventListener("click", onDocumentClick);
            document.addEventListener("keydown", onKeyDownHandler);
        }
        return () => {
            document.removeEventListener("click", onDocumentClick);
            document.removeEventListener("keydown", onKeyDownHandler);
        };
    }, [flyoutOpen]);
    if ((languages === null || languages === void 0 ? void 0 : languages.length) <= 1)
        return null;
    return (_jsxs(Wrapper, Object.assign({ "data-preview-id": previewId, "data-edit-type": dataEditType, alignByContent: alignByContent, ref: wrapperRef }, { children: [_jsxs(Dropdown, Object.assign({ ref: dropDownRef, onClick: toggleFlyout, onMouseDown: () => setFocused(false), onKeyUp: () => setFocused(true), onBlur: () => setFocused(false), "$focused": focused, "$selected": flyoutOpen, "data-testid": "dropdown" }, { children: [currentLanguage, _jsx(Icon, { symbol: flyoutOpen ? "chevron_up" : "chevron_down", width: "0.8125rem", color: theme.colors.grey13 })] })), (items === null || items === void 0 ? void 0 : items.length) >= 0 && (_jsx(FlyoutWrapper, Object.assign({ visible: flyoutOpen }, { children: _jsx(Flyout, { previewIdExtractor: previewIdExtractor, items: items, outlined: true, onClick: onClick, type: "withIcon", value: currentLanguage }) })))] })));
}
